import React, { useState, useEffect } from 'react'
import { getData, putData } from '../../../actions/servicesHttp'
import Button from 'react-bootstrap/Button'
import Header from '../../../components/generals/header'
import styles from '../../../css/generals/Checkbox.module.css'
import stylesPreferences from '../../../css/preferences/Preferences.module.css'
import stylesIndex from '../../../css/Index.module.css'
import { compareObj } from '../../../components/generals/toolsFunctions'
import Swal from 'sweetalert2'
import store from '../../../reducer/store'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function RSPreferences () {
  // ? urls de la API cuco
  const [rxartPreferencesUrl] = useState('rxartsecure/preferences')
  const [RSPreferences, setRSPreferences] = useState()
  const [preferencesToCompare, setPreferencesToCompare] = useState({})
  const { user } = store.getState()
  const role = user.roles
  const { t } = useTranslation('rxartPreferences')
  const navigate = useNavigate()

  const handleInputChange = (e) => {
    if (e.target.name === 'iniTimeout' || e.target.name === 'maxUsesDay' || e.target.name === 'advertensesDay' || e.target.name === 'maxBoot' || e.target.name === 'checkInterval') {
      setRSPreferences({
        ...RSPreferences,
        [e.target.name]: parseInt(e.target.value)
      })
    } else {
      setRSPreferences({
        ...RSPreferences,
        [e.target.name]: e.target.value
      })
    }
  }

  const requestRS = async (url, body, set, setCompare, method) => {
    try {
      const response = method === 'GET' ? await getData(url, undefined, navigate) : await putData(url, body, navigate)

      if (response.status === 200) {
        if (method === 'GET') {
          set(response?.data)
          setCompare(response?.data)
        } else {
          const res = await getData(url, undefined, navigate)
          if (res.status === 200) {
            set(res?.data)
            setCompare(res?.data)
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: `${t('message1')} ${method === 'GET' ? t('message2') : t('message3')} ${t('message4')}`,
              showConfirmButton: false,
              timer: 2000
            })
          }
        }

        if (method === 'PUT') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: t('message5'),
            showConfirmButton: false,
            timer: 1500
          })
        }
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `${t('message1')} ${method === 'GET' ? t('message2') : t('message3')} ${t('message4')}`,
          showConfirmButton: false,
          timer: 2000
        })
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: t('message6'),
        showConfirmButton: false,
        timer: 2000
      })
    }
  }

  useEffect(() => {
    const body = JSON.stringify({})
    requestRS(rxartPreferencesUrl, body, setRSPreferences, setPreferencesToCompare, 'GET')
  }, [rxartPreferencesUrl])

  const saveRSPreferences = (preferences, preferencesToCompare) => {
    const comparation = compareObj(preferences, preferencesToCompare)

    if (comparation) {
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: t('message7'),
        showConfirmButton: false,
        timer: 1500
      })
    } else {
      const body = preferences
      requestRS(rxartPreferencesUrl, body, setRSPreferences, setPreferencesToCompare, 'PUT')
    }
  }

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} margin="0" />
        <div>
          {role?.preferencesRxartSecurePage.parameters &&
            <>
              <h2 className={`${styles.subtitle}`}>{t('label1')}</h2>
             {/*  <div className={`${styles.componentBox} ${stylesPreferences.componentBoxRxartSecure}`}>
                <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                  <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>Días hasta el primer tiempo de espera:</label>
                  <input value={RSPreferences?.iniTimeout ? RSPreferences?.iniTimeout : ''} name="iniTimeout" onChange={handleInputChange} type="number" min={1} className={`${styles.focus} ${stylesPreferences.inputsPref}`} />
                </div>
                <p className={stylesPreferences.textRxartSecure}>Días de espera después de la instalación. Tan pronto como se reciba el primer ticket normal, el Fecha límite entra en vigor</p>
              </div> */}
              <div className={`${styles.componentBox} ${stylesPreferences.componentBoxRxartSecure}`}>
                <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                  <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label2')}</label>
                  <input value={RSPreferences?.maxUsesDay ? RSPreferences?.maxUsesDay : ''} name="maxUsesDay" type="number" onChange={handleInputChange} min={1} /* max={} */ className={`${styles.focus} ${stylesPreferences.inputsPref}`} />
                </div>
                <p className={stylesPreferences.textRxartSecure}>{t('description1')}</p>
              </div>
              <div className={`${styles.componentBox} ${stylesPreferences.componentBoxRxartSecure}`}>
                <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                  <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label3')}</label>
                  <input value={RSPreferences?.advertensesDay ? RSPreferences?.advertensesDay : 0} onChange={handleInputChange} name="advertensesDay" type="number" /* min={} max={} */ className={`${styles.focus} ${stylesPreferences.inputsPref}`} />
                </div>
                <p className={stylesPreferences.textRxartSecure}>{t('description2')}</p>
              </div>
              <div className={`${styles.componentBox} ${stylesPreferences.componentBoxRxartSecure}`}>
                <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                  <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label4')}</label>
                  <input value={RSPreferences?.maxBoot ? RSPreferences?.maxBoot : ''} onChange={handleInputChange} name="maxBoot" type="number" min={1} /* max={} */ className={`${styles.focus} ${stylesPreferences.inputsPref}`} />
                </div>
                <p className={stylesPreferences.textRxartSecure}>{t('description3')}</p>
              </div>
              <div className={`${styles.componentBox} ${stylesPreferences.componentBoxRxartSecure}`}>
                <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                  <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label5')}</label>
                  <input value={RSPreferences?.checkInterval ? RSPreferences?.checkInterval : ''} onChange={handleInputChange} name="checkInterval" type="number" min={1} className={`${styles.focus} ${stylesPreferences.inputsPref}`} />
                </div>
                <p className={stylesPreferences.textRxartSecure}>{t('description4')}</p>
              </div>
            </>}
          {role?.preferencesRxartSecurePage.parameters &&
            <>
              <h2 className={`${styles.subtitle} ${styles.margin}`}>{t('label6')}</h2>
              {/* <div className={`${styles.componentBox} ${stylesPreferences.boxMessage}`}>
                <div className={`${styles.containerDiv} ${stylesPreferences.alignMessage}`}>
                  <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>Mensaje de instalación/desinstalación:</label>
                  <textarea
                    name="msgIT"
                    minLength={11}
                    maxLength={216}
                    value={RSPreferences?.msgIT ? RSPreferences?.msgIT : ''}
                    onChange={handleInputChange}
                    className={`${styles.focus} ${stylesPreferences.message}`}
                  />
                </div>
              </div> */}
              <div className={`${styles.componentBox} ${stylesPreferences.boxMessage}`}>
                <div className={`${styles.containerDiv} ${stylesPreferences.alignMessage}`}>
                  <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label7')}</label>
                  <textarea
                    name="messagesAdvertense"
                    minLength={11}
                    maxLength={216}
                    value={RSPreferences?.messagesAdvertense ? RSPreferences?.messagesAdvertense : ''}
                    onChange={handleInputChange}
                    className={`${styles.focus} ${stylesPreferences.message}`}
                  />
                </div>
              </div>
              <div className={`${styles.componentBox} ${stylesPreferences.boxMessage}`}>
                <div className={`${styles.containerDiv} ${stylesPreferences.alignMessage}`}>
                  <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label8')}</label>
                  <textarea
                    name="messagesBlock"
                    minLength={11}
                    maxLength={216}
                    value={RSPreferences?.messagesBlock ? RSPreferences?.messagesBlock : ''}
                    onChange={handleInputChange}
                    className={`${styles.focus} ${stylesPreferences.message}`}
                  />
                </div>
              </div>
            </>}
        </div>
        <div className={`end-footer-body ${stylesPreferences.btnEnd}`}>
          <Button onClick={() => saveRSPreferences(RSPreferences, preferencesToCompare)} variant="dark">
            <i className="fas fa-save" style={{ marginRight: '0.5rem' }}></i>
            {t('button')}
          </Button>
        </div>
      </div>
    </div>
  )
}
